import React ,{useState}from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

const FooterPage = (props) => {
    const [Sylbos, setSylbos] = useState(null);
    return (
<div>
       
        <MDBFooter color="blue" className="font-small pt-4 mt-4" >
            <MDBContainer fluid className="text-center text-md-left">


                <MDBRow>


     
                    
                <MDBCol md="6" style={{textAlign: 'right'}}>
                        <h5 className="title">בונה מערכת לסטודנטים של בראודה</h5>
                        <h6 className="title" style={{ 'color': 'green' }}>🙌 מספר מערכות שנבנו עד היום:
        {" "+props.countBuild}  </h6>

                        <p>
                            תרגישו חופשי להשתמש ולשתף עם סטודנטים של בראודה
            </p>
                        <p style={{color:'red'}}>
                          
                             שימו לב שכל השעות התמלאו בצורה תקינה 
                      
            </p>

            <p style={{color:'red'}}>    בנוסף המערכת לא עושה הבדלה בין קורסים משותפים של מחלקות כרגע  </p>
                    </MDBCol>
                    <MDBCol md="6" style={{textAlign: 'right'}}>
                        <h5 className="title">2021 קישורים לסילבוסים של המחלקות</h5>
                        <ul>
                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/wp-content/uploads/2020/08/Software-prog-tashpa-new.pdf" target="_blank">תכנה</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/wp-content/uploads/2020/08/Information-sys-prog-tashpa-1.pdf" target="_blank">מערכות מידע</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/wp-content/uploads/2019/08/Shnaton-Braude-2019-2020.pdf!" target="_blank">חשמל</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/wp-content/uploads/2020/08/shnaton-machine-9.8.2020.pdf!" target="_blank">מכונות</a>
                            </li>

                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/wp-content/uploads/2020/08/shnaton-upd-2020-2021.pdf" target="_blank">תעשיה וניהול</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="https://w3.braude.ac.il/department/bio/bsc-bio/" target="_blank">ביו</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="https://braude.ac.il/wp-content/uploads/2019/06/%D7%A4%D7%A8%D7%A9%D7%99%D7%95%D7%AA_%D7%9C%D7%99%D7%9E%D7%95%D7%93.pdf" target="_blank">אופטיקה</a>
                            </li>
                            <li className="list-unstyled">
                                <a href="   https://w3.braude.ac.il/wp-content/uploads/2019/12/%D7%9E%D7%AA%D7%9E%D7%98%D7%99%D7%A7%D7%94-%D7%A9%D7%99%D7%9E%D7%95%D7%A9%D7%99%D7%AA-%D7%AA%D7%9B%D7%A0%D7%99%D7%AA-%D7%9C%D7%99%D7%9E%D7%95%D7%93%D7%99%D7%9D-10.12.19.pdf" target="_blank">מתמטיקה שימושית</a>
                            </li>


                        </ul>
                    </MDBCol>
                 
                </MDBRow>



               
                  
               
                  
            </MDBContainer>
            <div className="footer-copyright text-center py-3">
                    
        
            </div>
        </MDBFooter>
  
        </div>
    );
}

export default FooterPage;